import { defineComponent } from '@vue/composition-api';

/**
 * @deprecated Use SdsIcon instead - this should not be used directly
 */
var script = defineComponent({
    name: 'Icon',
    functional: true,
    props: {
        size: {
            type: String,
            default: '',
            required: false,
        },
    },
});

export default script;
